import gql from 'graphql-tag';

const printProductBaseDetails = gql`
  fragment printProductBaseDetails on PrintProduct {
    id
    name
    preview_asset_image {
      id
      url
      width
      height
    }
    sizes {
      total
      records {
        id
        print_size {
          id
          name
        }
        orientations
        mounts {
          total
        }
        total_price {
          value
          currency
        }
      }
    }
  }
`;

export default printProductBaseDetails;
